import React from "react";
import { useNavigate } from "react-router-dom";
import "./NotFound.css";
import ChantButton from "../../CommonComponents/ChantButton/ChantButton";

const NotFound = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/");
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <div className="not-found-animation">
          <div className="chant-wave">404</div>
        </div>

        <h1 className="not-found-title">Page Not Found</h1>

        <p className="not-found-message">
          The page you&apos;re looking for doesn&apos;t exist or has been moved.
        </p>

        <div className="not-found-actions">
          <ChantButton onClick={handleGoBack} type="primary">
            Go Back
          </ChantButton>
          <ChantButton onClick={handleGoHome} type="secondary">
            Go Home
          </ChantButton>
        </div>

        <div className="not-found-footer">
          <p className="not-found-hint">
            Need help? Contact support or check the navigation menu.
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
